// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const ScreenAnimatorContract = contract({
  name: "ScreenAnimator",
  description: "Wrap ANY screen or section in a directed camera — a \"live demo",
  import: "@gradeui/ui",
  aliases: ["screen animator","camera","camera tour","director","demo","product demo","zoom pan","spotlight","ken burns","presenter"],
  composesWith: ["AppShell","ThreeScene","Card","Grid","the whole component set (it wraps a screen)"],
  styleDefaults: {"ScreenAnimator":"gds-screen-animator"},
  props: {
  "shots": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "the tour. Each",
  },
  },
});
